export default __webpack_public_path__ + "static/media/-1-1715937950917.19141805.png";